import { NgModule } from '@angular/core';
import { AlphanumericOnlyDirective } from './directives/alphanumeric-only.directive';
import { AuthorizedDisabledDirective } from './directives/authorized-disable.directive';
import { AuthorizedHideDirective } from './directives/authorized-hide.directive';
import { CaseDisabledDirective } from './directives/case-disabled.directive';
import { DisabledConditionsDirective } from './directives/disabled-conditions.directive';
import { FileDropDirective } from './directives/file-drop.directive';
import { NgVar } from './directives/ngvar.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { ScrollSpyDirective } from './directives/scroll-spy.directive';

@NgModule({
    declarations: [
        ScrollSpyDirective,
        FileDropDirective,
        NumberOnlyDirective,
        AlphanumericOnlyDirective,
        NgVar,
        AuthorizedDisabledDirective,
        AuthorizedHideDirective,
        CaseDisabledDirective,
        DisabledConditionsDirective
    ],
    imports: [],
    exports: [
        ScrollSpyDirective,
        FileDropDirective,
        NumberOnlyDirective,
        AlphanumericOnlyDirective,
        NgVar,
        AuthorizedDisabledDirective,
        AuthorizedHideDirective,
        CaseDisabledDirective,
        DisabledConditionsDirective
    ]
})
export class DirectivesModule {}
